import {defineMessages} from 'react-intl';

export default defineMessages({
  paragraph: {
    defaultMessage: 'We invite you to <strong>share your thoughts</strong> and discuss them with other people.',
    id: 'DiscussPage.DiscussPageAnswerForm.Paragraph',
  },
});
